<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const message = computed(() => String(route.query.message || 'Сессия приложения недоступна. Откройте S-A-S Forms снова из Bitrix24.'))
</script>
<template>
  <div class="center-card">
    <h1>Не удалось открыть S-A-S Forms</h1>
    <p>{{ message }}</p>
  </div>
</template>
